<template>
    <div class="col-md-12">
        <base-button block type="default" class="icon icon-shape border-success bg-success rounded-circle text-white mt--6 float-right" @click="modalAdd = true">
            <i class="ni ni-fat-add"></i>
        </base-button>

        <modal :show.sync="modalAdd"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-xl">
            <base-header class="header pb-2 pb-2 pt-5 pt-md-8 d-flex align-items-center">
                <!-- Mask -->
                <span class="mask bg-gradient-login_varient opacity-8"></span>
                <!-- Header container -->
            </base-header>

            <div class="container-fluid mt--7">
                <div class="row">
                    <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Ajouter une devise</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                
                                <h6 class="heading-small text-muted mb-4">Informations</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Nom de la devise"
                                                        placeholder="Nom de la devise"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="devise.nom"
                                            />
                                            <transition name="fade">
                                                <div  v-if="nomMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le nom est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Symbole de la devise"
                                                        placeholder="Symbole de la devise"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="devise.symbole"
                                            />
                                            <transition name="fade">
                                                <div  v-if="symboleMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le symbole est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <base-button v-on:click="submitForm" type="success col-lg-12">Ajouter cette devise</base-button><br><br>
                                <transition name="fade">
                                    <div  v-if="errordevise" 
                                        class="alert alert-danger" 
                                        role="alert">
                                        Problème lors de l'ajout...
                                    </div>
                                    <div  v-if="gooddevise" 
                                        class="alert alert-success" 
                                        role="alert">
                                        Devise ajoutée
                                    </div>
                                </transition>
                            </form>
                        </template>
                    </card>
                </div>
                </div>
                <br>
            </div>
        </modal>
    </div>
</template>
<script>
import constvar from '@/const'
import modal from "@/components/Modal";

export default {
    name: "DeviseAddModal",
    components: {
        modal
    },
    data() {
      return {
        modalAdd: false,
        required: true,
        devise: {
            nom: '',
            symbole: '',
        },
        errordevise: false,
        gooddevise: false,
        nomMissing: 0,
        symboleMissing: 0,
      }
    },
    methods: {
        submitForm: async function() {
            if(!this.devise.nom) { this.nomMissing = 1 } else { this.nomMissing = 0 }
            if(!this.devise.symbole) { this.symboleMissing = 1 } else { this.symboleMissing = 0 }
            if(this.nomMissing || this.symboleMissing) { return; }

            const params = new FormData();
            params.append('nom', this.devise.nom);
            params.append('symbole', this.devise.symbole);
    
            const response = await fetch(constvar.api_url+'devise', {
                method: 'POST',
                credentials: 'include',
                body: params
            });
            const json = await response.json();
            if(json.id) {
                this.$emit('deviseadded', true)
                this.modalAdd = false
            } else {
                this.errordevise = true
                setTimeout(()=>{
                this.errordevise = false
                },3000);
            } 
        },
    },
    watch: {
    }
};
</script>
<style>
    .style-chooser .vs__dropdown-toggle {
        border: none;
    }
</style>